import { render, staticRenderFns } from "./ManageMyAds.vue?vue&type=template&id=64590039&scoped=true"
import script from "./ManageMyAds.vue?vue&type=script&lang=ts"
export * from "./ManageMyAds.vue?vue&type=script&lang=ts"
import style0 from "./ManageMyAds.vue?vue&type=style&index=0&id=64590039&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64590039",
  null
  
)

export default component.exports